import { render, staticRenderFns } from "./HotGoodsTitle.vue?vue&type=template&id=e9b22916&scoped=true&"
import script from "./HotGoodsTitle.vue?vue&type=script&lang=js&"
export * from "./HotGoodsTitle.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/hotgoodstitle.css?vue&type=style&index=0&id=e9b22916&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b22916",
  null
  
)

export default component.exports